import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

import { environment } from 'environments/environment';
import { User } from 'app/auth/models';

export interface UserProfileUpdate {
  firstName: string;
  lastName: string;
  avatar: string;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  private userProfileSubject = new BehaviorSubject<UserProfileUpdate | null>(null);
  userProfile$ = this.userProfileSubject.asObservable();

  setUserProfile(profile: UserProfileUpdate) {
    this.userProfileSubject.next(profile);
  }

  /**
   * Get all users
   */
  getAll() {
    return this._http.get<User[]>(`${environment.apiUrl}/users`);
  }

  /**
   * Get user by id
   */
  getById(id: number) {
    return this._http.get<User>(`${environment.apiUrl}/users/${id}`);
  }
}
